import React, { FC, useEffect } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import { contractorLocationsRestCrudThunksForSupplier } from '../../thunks/contractor_locations_thunks';
import ContractorLocationPageDisplay from './ContractorLocationPageDisplay';
import { updateNavbarState } from '../../actions/navbar_actions';
import { getBackLinkStates } from '../../utils/HistoryUtils';

const { Content } = Layout;

require('../supplier_locations_detail_details_page/SupplierLocationsDetailDetailsPage.less');

const DEFAULT_BACK_LINK_TEXT = 'Back to locations';
const DEFAULT_BACK_LINK_TO = `/supplier/contractor_clients/overview/all`;

const ContractorLocationDetailDetailsPage: FC<any> = ({
	contractorLocation,
	locationsFetching,
	location,
	updateNavbar,
}): React.ReactElement => {
	const fetching = locationsFetching && !nullSafeGet('id', contractorLocation);

	useEffect(() => {
		const { backLinkText: text, backLinkTo: link } = getBackLinkStates(
			location,
			DEFAULT_BACK_LINK_TO
		) as any;

		updateNavbar(text || DEFAULT_BACK_LINK_TEXT, link || DEFAULT_BACK_LINK_TO);
	}, []);

	return fetching ? (
		<PageLoadingPlaceholder />
	) : (
		<Content className="supplierLocationsDetailDetailsPage">
			<ContractorLocationPageDisplay
				key={nullSafeGet('id', contractorLocation)}
				record={contractorLocation}
				locationsFetching={fetching}
				isDetailPage
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	locationsFetching: state.contractor_locations.fetching,
	contractorLocation: getEntityById(ownProps.match.params.id, state.contractor_locations),
});

const mapDispatchToProps = (dispatch) => ({
	getLocation: (id) => dispatch(contractorLocationsRestCrudThunksForSupplier.readOne(id)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ContractorLocationDetailDetailsPage)
);
